import { getOptimalUrl } from "./getOptimalUrl"

export function getPhysicalAlbumCount(
  folderId: string | null,
  folderName: string,
  allFiles: Array<{ id: string; folderId: string; url: string; compressedUrl?: string; b2Url?: string; b2CompressedUrl?: string }>,
  physicalAlbum: Array<{ id: string }>,
  isVideosFolder: boolean = false
) {
  if (!allFiles || !physicalAlbum) return 0

  let folderFiles: Array<{ id: string; folderId: string; url: string; compressedUrl?: string; b2Url?: string; b2CompressedUrl?: string }> = []

  if (folderName === "All Photos") {
    // Filter for photos only (non-video files)
    folderFiles = allFiles.filter(file => !isVideo(getOptimalUrl(file, false)))
  } else if (folderName === "All Videos") {
    // Filter for videos only
    folderFiles = allFiles.filter(file => isVideo(getOptimalUrl(file, false)))
  } else if (folderId) {
    // Filter for specific folder
    folderFiles = allFiles.filter(file => file.folderId === folderId)
  } else {
    return 0
  }

  // Count how many files from this folder are in physical album
  return folderFiles.filter(file =>
    physicalAlbum.some(pa => pa.id === file.id)
  ).length
}

function isVideo(url: string): boolean {
  const videoExtensions = ['.mp4', '.mov', '.avi', '.mkv', '.webm', '.m4v']
  return videoExtensions.some(ext => url.toLowerCase().includes(ext))
}